<template>
  <div class="home-box">
    <keep-alive include="BookShelf,BookDiscover">
      <router-view></router-view>
    </keep-alive>
    <NvBottomNav />
  </div>
</template>

<script>
import NvBottomNav from "@/components/layout/NvBottomNav";
import { getGlobalConfig, getUserInfo, getLocalReadProgress, syncReadProgress, syncShelf } from "@/service/api";

export default {
  components: {
    NvBottomNav
  },
  methods: {
    getLocal() {
      let progress = getLocalReadProgress();
      let readHistory = progress.map(p => {
        const obj = {
          book_id: p.book_id,
          chapter_id: p.chapter_id,
          page_index: 1,
          read_seconds: 0
        };
        return obj;
      });
      let lib = progress
        .filter(p => {
          return p.inLib;
        })
        .map(i => {
          return {
            book_id: i.book_id
          };
        });
      return [readHistory, lib];
    },
    syncLocal() {
      const [history, shelf] = this.getLocal();
      syncReadProgress({ data: history });
      syncShelf({ data: shelf });
    }
  },
  mounted() {
    getGlobalConfig().then(res => {
      this.$store.commit("SET_GLOBAL_CONFIG", res);
    });
    getUserInfo().then(res => {
      this.$store.commit("SET_USER", res || {});
    });
    this.syncLocal();
  }
};
</script>

<style lang="scss" scoped>
// .home-box {}
</style>
